import { call, put, select, takeLatest } from 'redux-saga/effects'

import { selectAuthData } from '@/containers/Login/AuthSelectors'
import getAPIConfig from '@/shared/tools/getAPIConfig'
import { showSnackbar, SNACKBAR_TYPES } from '@/shared/tools/notifications/notification'

import { searchRequest, searchSuccess, searchEmpty, searchFailure } from './cacheSlice'

export const cacheActions = {
  SEARCH: 'DEVTOOLS_NEW/CACHE/SEARCH',
}

function* searchCacheSaga({ enqueue, t, payload }) {
  yield put(searchRequest())

  try {
    const { extraRoutes, authTokenSession, country } = yield select(selectAuthData)
    const template = extraRoutes?.devTools?.cache?.search
    if (!template) {
      const message = t?.('cache.errors.missing_search_url') || 'Missing cache search url'
      yield put(searchFailure(message))
      if (enqueue) yield call(showSnackbar, enqueue, { type: SNACKBAR_TYPES.ERROR, message })
      return
    }

    const cacheKey = payload?.cacheKey
    const url = template.replace('*', encodeURIComponent(cacheKey)) + `?lang=${country}`
    const config = yield call(getAPIConfig, { method: 'GET', authTokenSession })
    const response = yield call(fetch, url, config)

    if (response.status === 204) {
      yield put(searchEmpty())
      return
    }

    const data = yield call([response, response.json])

    if (!response.ok) {
      const message = data?.error_text || t?.('cache.errors.not_found') || 'Cache key not found'
      yield put(searchFailure(message))
      return
    }

    yield put(searchSuccess({ value: data }))
  } catch (error) {
    const message = error?.message || 'Error searching cache'
    yield put(searchFailure(message))
    if (enqueue) {
      yield call(showSnackbar, enqueue, { type: SNACKBAR_TYPES.ERROR, message })
    }
  }
}

export default function* cacheSagas() {
  yield takeLatest(cacheActions.SEARCH, searchCacheSaga)
}
